import React from "react";
import { Medal } from "./Medal";
import { Category, Date, Header, MedalWrapper, Metadata, Result, Thumbnail, Tier, Tile, Title } from "./SportTile.styles";
export const TILE_SIZE = 228;

export const SportTile = (myProps) => {
  const {
    thumbnail,
    sport,
    category,
    tier,
    date,
    result,
    medals,
    onTileSelect,
    full
  } = myProps;
  return (
    <Tile hasThumbnail={!!thumbnail} isClickable={!!full} onClick={() => full && onTileSelect(myProps)}>
      {thumbnail && (
        <Thumbnail
          src={thumbnail}
          width={TILE_SIZE}
          height={TILE_SIZE}
        ></Thumbnail>
      )}
      <Metadata>
        <Header>
          <Title>{sport}</Title>
          <Category>{category}</Category>
        </Header>
        <Tier>{tier}</Tier>
        <Date>{date}</Date>
        <Result>
          {result.split("\n").map((resultLine, i) => (
            <div key={resultLine + i}>{resultLine}</div>
          ))}
        </Result>
        <MedalWrapper>
          {medals &&
            Object.keys(medals).map((cls, i) => (
              <Medal key={medals[cls] + i} medalClass={cls} label={medals[cls]} />
            ))}
        </MedalWrapper>
      </Metadata>
    </Tile>
  );
};
